"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ticker = void 0;
/**
 * Тикер
 */
class Ticker {
    /**
     * Конструктор
     */
    constructor(workFunc) {
        this.workFunc = workFunc;
        /**
         * Интервал
         */
        this.interval = 1000;
        this.step = this.step.bind(this);
    }
    /**
     * Запускает счетчик
     */
    start() {
        this.expected = Date.now() + this.interval;
        this.timeout = setTimeout(this.step, this.interval);
    }
    /**
     * Останавливает счетчик
     */
    stop() {
        clearTimeout(this.timeout);
    }
    /**
     * Обрабатывает тик
     */
    step() {
        const drift = Date.now() - this.expected;
        this.workFunc();
        this.expected += this.interval;
        this.timeout = setTimeout(this.step, Math.max(0, this.interval - drift));
    }
}
exports.Ticker = Ticker;
